
import { CORE_API_ENDPOINT } from '../lib'
import MyManager from '../core/business/MyManager'

export default class ReportManager extends MyManager {
	async sendReport(data) {
		try {
			const options = {
				method: this.requestMethod.POST,
				url: `${CORE_API_ENDPOINT}/userreport`,
				data: data,
			}

			let res = await this.requestAction(options, null)

			return res
		} catch (error) {
			return false
		}
	}
}


// WEBPACK FOOTER //
// ./src/business/ReportManager.js